import axios from "./axios";

export const tasksApi = {
  // Get all tasks
  getTasks: async (params = {}) => {
    return axios.get("/tasks", { params });
  },

  // Get a single task by ID
  getTask: async (id) => {
    return axios.get(`/tasks/${id}`);
  },

  // Create a new task
  createTask: async (data) => {
    return axios.post("/tasks", {
      task: data,
    });
  },

  // Update an existing task
  updateTask: async (id, data) => {
    return axios.put(`/tasks/${id}`, {
      task: data,
    });
  },

  // Delete a task
  deleteTask: async (id) => {
    return axios.delete(`/tasks/${id}`);
  },

  // Toggle finished status
  toggleFinished: async (id) => {
    return axios.post(`/tasks/${id}/toggle_finished`);
  },
};

